
<div class="dns-access-wrap">
  <div class="heading-n-desc-wrap">
    <div class="main-heading-wrap">
      <h3 class="main-heading">Set URLs for your environments</h3>
    </div>

    <div class="main-desc-wrap">
      <p class="main-desc">
        This is a one-time setup and should take no longer than 15 minutes of
        your time.
      </p>
    </div>
  </div>

  <div class="label-n-input-wrap">
    <h3 class="label-heading">Staging environment URL:</h3>
    <p class="small-desc">Define your staging environment URL:</p>
    <input
      class="url-input"
      type="text"
      value=""
      placeholder="staging.builder.yourapp.com"
    />

    <div class="icon-n-text-wrap">
      <i class="fal fa-info-circle"></i>
      <span>Example: testing.keap.com</span>
    </div>
  </div>

  <div class="label-n-input-wrap">
    <h3 class="label-heading">Production environment URL:</h3>
    <p class="small-desc">Define your production environment URL:</p>
    <input
      class="url-input"
      type="text"
      value=""
      placeholder="production.builder.yourapp.com"
    />

    <div class="icon-n-text-wrap">
      <i class="fal fa-info-circle"></i>
      <span>Example: app.keap.com</span>
    </div>
  </div>

  <div class="label-n-input-wrap">
    <h3 class="label-heading">Custom CDN URL:</h3>
    <p class="small-desc">
      Create custom DNS CNAME record for your customers to alias
    </p>
    <input
      class="url-input"
      type="text"
      value=""
      placeholder="pages.yourapp.com"
    />

    <div class="icon-n-text-wrap">
      <i class="fal fa-info-circle"></i>
      <span>Example: pages.keap.com</span>
    </div>
  </div>

  <div class="dns-config-btn-wrap">
    <cvt-button
      class="ib-done-btn"
      :color="''"
      :mode="'primary'"
      :size="'md'"
      :full-width="true"
      :text="'Continue to DNS Configuration'"
      :special-padding="'20px 0px'"
      @click="continueToConfigDns"
    >
    </cvt-button>
  </div>
</div>
